import { render, staticRenderFns } from "./FormSpinbuttonFormater.vue?vue&type=template&id=380b4397"
import script from "./FormSpinbuttonFormater.vue?vue&type=script&lang=js"
export * from "./FormSpinbuttonFormater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports